import { SsoModalActionType } from "../actiontype/sso-modal.actiontype";
import ApiStatus from "../constants/api-status.enum";
import AuthorizationActionType from "../actiontype/authorization.actiontype";
import CommonActionType from "../actiontype/common.actiontype";

const initialState = {
    ssoAccountList: '',
    selectedSiNumber: '',
    selectedLob: '',
    ssoProfileApiStatus: '',
    ssoProfileApiResponse: ''
}

export default function(state = initialState, action) {
    switch(action.type) {
        case SsoModalActionType.SET_SSO_ACCOUNT_LIST:
        return {
            ...state,
            ssoAccountList: action.payload
        }
        case SsoModalActionType.SET_SELECTED_SI_NUMBER:
        return {
            ...state,
            selectedSiNumber: action.payload
        }
        case SsoModalActionType.SET_SELECTED_LOB:
        return {
            ...state,
            selectedLob: action.payload
        }
        case AuthorizationActionType.FETCH_SSO_PROFILE_LOADING:
        return {
            ...state,
            ssoProfileApiStatus: ApiStatus.LOADING,
            ssoProfileApiResponse: action.payload
        }
        case AuthorizationActionType.FETCH_SSO_PROFILE_SUCCESS:
        return {
            ...state,
            ssoProfileApiStatus: ApiStatus.SUCCESS,
            ssoProfileApiResponse: action.payload
        }
        case AuthorizationActionType.FETCH_SSO_PROFILE_ERROR:
        return {
            ...state,
            ssoProfileApiStatus: ApiStatus.ERROR,
            ssoProfileApiResponse: action.payload
        }
        case CommonActionType.RESET_STATE:
            return { ...initialState }
        default:
        return state;
    } 
}